import Joi from 'joi'

import { validator } from 'utils'

const role = Joi.object({
  name: validator.getRuleString('ชื่อ'),
  surname: validator.getRuleString('นามสกุล'),
  email: validator.getRuleString('อีเมล'),
  user_role_id: validator.getRuleNumber('role'),
}).options({ allowUnknown: true })

export default role
